import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=318f08ed&"
import script from "./addList.vue?vue&type=script&lang=js&"
export * from "./addList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318f08ed')) {
      api.createRecord('318f08ed', component.options)
    } else {
      api.reload('318f08ed', component.options)
    }
    module.hot.accept("./addList.vue?vue&type=template&id=318f08ed&", function () {
      api.rerender('318f08ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/meterManager/houseMeter/addList.vue"
export default component.exports